import React from 'react'
import { Grid, TextField } from '@mui/material'
import AddressAutocomplete from '../../patientTransport/components/AddressAutocomplete'
import {
  EVENT_ADDRESS_FIELDS,
  eventAddressFromLookup,
} from '../../../helpers/eventAddress'

/**
 * Postcode/address lookup plus editable address lines for an event venue.
 * `value` is the eventAddress object; `onChange` receives the next one.
 * Editing a line by hand keeps the looked-up map point — the lookup result
 * is only replaced when a new address is picked.
 */
const EventAddressFields = ({
  value,
  onChange,
  legacyLocation,
  size = 'small',
}) => {
  const address = value || {}
  const hasPoint = address.location?.coordinates?.length === 2

  const helperText = hasPoint
    ? undefined
    : legacyLocation
      ? `Previously recorded as "${legacyLocation}". Pick an address to add a map point.`
      : 'Selecting an address sets the map point used to centre the control room map.'

  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12}>
        <AddressAutocomplete
          label="Find address or postcode"
          address={{
            addressLine1: address.lineOne,
            addressLine2: address.lineTwo,
            town: address.town,
            postCode: address.postCode,
            location: address.location,
          }}
          onSelect={(option) => onChange(eventAddressFromLookup(option, address))}
          helperText={helperText}
        />
      </Grid>
      {EVENT_ADDRESS_FIELDS.map(([field, label]) => (
        <Grid item xs={12} sm={6} key={field}>
          <TextField
            value={address[field] ?? ''}
            onChange={(e) => onChange({ ...address, [field]: e.target.value })}
            label={label}
            fullWidth
            autoComplete="off"
            size={size}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default EventAddressFields
